<template>
    <div name="reason" class="reason">
        <span class="text1">왜 솔닥을 선택해야 할까요?</span>
        <span class="text2">숫자가 증명하는 <br>압도적인 1등</span>
        <span class="text3">역시 솔닥입니다</span>
        <!-- <div class="box" style="margin-top: 41px;">
            <img class="award-box" src="../assets/award1.png" />
            <img class="award-box" src="../assets/award2.png" />
        </div> -->
        <div class="box" style="margin-top: 41px;">
            <img class="award-box" src="../assets/award3.png" />
            <img class="award-box" src="../assets/award4.png" />
        </div>
        <div class="box">
            <img class="award-box" src="../assets/award5.png" />
            <img class="award-box" src="../assets/award6.png" />
        </div>
        <div class="">
            <span class="text4"><span style="color: #008DEF">*</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024년 한경비즈니스 주최 소비자만족지수 비대면진료 부문 1위<br/><span style="color: #008DEF">**</span>&nbsp;&nbsp;&nbsp;&nbsp;2023년 4차 산업혁명 파워코리아 대전 보건복지부 장관상 수상</span>
        </div>
        <span class="text1" style="margin-top: 124px;">애매하고 헷갈리는 진료과목 대신</span>
        <span class="text2">직관적인</span>
        <span class="text3">증상별 진료 예약</span>
        <div class="box" style="margin-top: 52px;">
            <div class="box2">
                <img class="department-box" src="../assets/moi.png" />
                <img class="department-box" src="../assets/flu.png" />
                <img class="department-box" src="../assets/kids.png" />
                <img class="department-box" src="../assets/woman.png" />
            </div>
            <div class="box2" style="margin-top: 63px;">
                <img class="department-box" src="../assets/hair.png" />
                <img class="department-box" src="../assets/eyedry.png" />
                <img class="department-box" src="../assets/allergy.png" />
                <img class="department-box" src="../assets/etc.png" />
            </div>
            <div class="box2" style="margin-top: 130px;">
                <img class="department-box" src="../assets/acne.png" />
                <img class="department-box" src="../assets/diet.png" />
                <img class="department-box" src="../assets/chronic.png" />
            </div>
        </div>  
        <img class="blur" src="../assets/blur.png" />
    </div>
</template>

<script>
export default {   
    name: 'reason'
}
</script>

<style scoped>
    .reason {
        width: 100%;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 103px;
        padding-left: 20px;
        position: relative;
        padding-bottom: 70px;
    }
    .blur {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .text1 {
        color: #666;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text2 {
        color: #000;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 126.667% */
        margin-top: 12px;
    }
    .text3 {
        color: #0F90E8;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px;
    }
    .text4{
        color: #999;
font-family: Pretendard;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 14px;
    }
    .box {
        width: 100%;
        display: flex;
    }
    .box2{
        display: flex;
        flex-direction: column;
        width: calc(33% - 18px);
        margin-right: 8px;
    }
    .award-box {
        width: calc(50% - 7px - 20px);
        margin-right: 7px;
        margin-bottom: 10px;
    }

    .department-box {
        width: 100%;
        margin-bottom: 12px;
    }



</style>


// WEBPACK FOOTER //
// src/components/Reason.vue